/**
 *
 * @param key
 * @returns
 */
export const getLocalStorage = (key: string): string | null => {
  if (typeof window !== "undefined") {
    return window.localStorage.getItem(key);
  }
  return null;
};

/**
 *
 * @param key
 * @param value
 */
export const setLocalStorage = (key: string, value: string): void => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(key, value);
  }
};

/**
 *
 * @param key
 */
export const deleteLocalStorage = (key: string): void => {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(key);
  }
};
